import { themeColors } from '@/theme/colors';
import { Flex } from '@lego/klik-ui';
import type { PropsWithChildren } from 'react';
import Studs from '../assets/studs.svg?react';

const STUDS_HEIGHT = 18;

type BrickBoxProps = {
  color?: string;
};

const BrickBox = ({
  children,
  color = themeColors.interactive.primary.subtle.selected,
}: PropsWithChildren<BrickBoxProps>) => {
  return (
    <div>
      <Flex>
        <div
          style={{
            backgroundColor: color,
            width: '100%',
            height: `${STUDS_HEIGHT}px`,
          }}
        />
        <div style={{ color: color }}>
          <Studs />
        </div>
      </Flex>
      <div style={{ backgroundColor: color, width: '100%' }}>{children}</div>
    </div>
  );
};
export default BrickBox;
